"use client";

import { ChartCard } from "@/components/ui/chart-card";
import { Skeleton } from "@/components/ui/skeleton";
import { MetricCardSkeleton, LegendSkeleton } from "@/components/ui/chart-skeletons";

export default function MarketConcentrationSkeleton() {
  return (
    <ChartCard
      title="Market Concentration"
      subtitle="Herfindahl-Hirschman Index (HHI) measures market concentration. Lower scores indicate competitive markets, higher scores suggest oligopoly."
    >
      <div className="mb-4">
        <MetricCardSkeleton count={2} cols={2} />
      </div>

      {/* Area Chart */}
      <div className="h-56 -mx-2">
        <Skeleton className="h-full w-full rounded-md" showLoadingText />
      </div>

      <div className="mt-3">
        <LegendSkeleton itemCount={2} layout="horizontal" showIcon={false} />
      </div>
    </ChartCard>
  );
}
